import React from 'react';
import Box from '@mui/material/Box';

const defaultColors = {
	// logoBackground: '#000000',
};

const CustomerLogo = (props) => {
	const {
		url,
		colors = {},
		padding = 0,
		borderRadius = 1,
		maxHeight = 100,
		maxWidth = '100%',
	} = props;

	const c = { ...defaultColors, ...colors };

	const height = maxHeight - 2 * padding;

	return (
		<Box sx={{ display: 'inline-flex', backgroundColor: c.logoBackground, overflow: 'hidden', borderRadius, maxWidth, padding: `${padding}px` }}>
			<img src={url} style={{ height, maxWidth, objectFit: 'contain', verticalAlign: 'middle' }} />
		</Box>
	);
};

CustomerLogo.type = 'CustomerLogo';

export default CustomerLogo;